import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const fetchBySegment = async (segment_id: any) => {
  const response = await fetch(
    `${REACT_APP_ARPS_BASE_URL}/customers/segments/${segment_id}`
  );
  const result = await response.json();
  return result;
};

export default fetchBySegment;
